import React from 'react';

import classes from './QuestionSlider.module.scss';

const QuestionSlider = ({sliderProps}) => {
  return (
    <div className={classes['slider-inputs-container']}>
      <label htmlFor="min">
        Min
        <input
          className="input"
          id="min"
          name="min"
          type="text"
          value={sliderProps.min}
          disabled
        />
      </label>
      <label htmlFor="max">
        Max
        <input
          className="input"
          id="max"
          name="max"
          type="text"
          value={sliderProps.max}
          disabled
        />
      </label>
      <label htmlFor="step">
        Step
        <input
          className="input"
          id="step"
          name="step"
          type="text"
          value={sliderProps.step}
          disabled
        />
      </label>
      <label htmlFor="defaultValue">
        Default Value
        <input
          className="input"
          id="defaultValue"
          name="defaultValue"
          type="text"
          value={sliderProps.defaultValue ?? ''}
          disabled
        />
      </label>
    </div>
  );
};

export default QuestionSlider;
